/* eslint-disable import/prefer-default-export */
export {default as statsMinus} from "./statsMinus";
